// cspell:words Evett
import { isRedoEmailAddress } from "@redotech/redo-model/redo-domains";
import { memo } from "react";
import * as css from "./thursday-boot-warning-banner.module.css";

const THURSDAY_BOOT_TEAM_ID = "65fb04bbb4a972000754cbdc";

export const ThursdayBootWarningBanner = memo(
  function ThursdayBootWarningBanner({
    teamId,
    email,
  }: {
    teamId: string | undefined;
    email: string | undefined;
  }) {
    if (!teamId || !email) {
      return null;
    }
    if (teamId !== THURSDAY_BOOT_TEAM_ID) {
      return null;
    }
    if (!isRedoEmailAddress(email)) {
      return null;
    }

    return (
      <div
        className={css.banner}
        data-testid="thursday-boot-warning-banner"
        role="alert"
      >
        <span aria-hidden className={css.icon}>
          ⚠
        </span>
        <span className={css.message}>
          <strong>WARNING:</strong> Making ANY changes to Thursday Boot
          Company&apos;s settings, orders, or data without explicit permission
          from Aaron Evett is a fireable offense.
        </span>
        <span aria-hidden className={css.icon}>
          ⚠
        </span>
      </div>
    );
  },
);
